module.exports = __webpack_public_path__ + "static/media/hotel.75057342.svg";